import Vue from 'vue'
//assessments page and common componets
export const AssessmentsIndexPage = Vue.component('assessments-index-page', require('./index/AssessmentIndexPage'));
export const AssessmentsCard = Vue.component('assessments-card', require('./index/AssessmentCard'));
export const Navigation = Vue.component('assessments-navigation', require('./common/Navigation'));
export const ProgressBar = Vue.component('assessment-progress-bar', require('./common/InteresProgressBar'));

//interests page
export const InterestsPage = Vue.component('interest-page', require('./interests/InterestsPage'));
export const InterestsFacesAssessments = Vue.component('faces-assessment', require('./interests/FacesAssessment'));
export const InterestsFacesQuestions = Vue.component('faces-question', require('./interests/FacesQuestion'));

//skills page
export const SkillsPage = Vue.component('skills-page', require('./skills/SkillsPage'));
export const SkillsQuestions = Vue.component('skills-questions', require('./skills/SkillsQuestions'));
export const SkillsAnswers = Vue.component('skills-answers', require('./skills/SkillsAnswers'));

//literacy numeracy pages
export const LiteracyNumeracyPage = Vue.component('literacy-numeracy-page', require('./numeracyLiteracy/LiteracyNumeracyPage'));
export const LiteracyAnswers = Vue.component('literacy-numeracy-answers', require('./numeracyLiteracy/LiteracyAnswers'));




// WEBPACK FOOTER //
// ./resources/assets/js/views/assessments/index.js